<div class="container-custom-header">
    <div class="container-fluid animate__animated animate__fadeIn">
        <div class="">
            <div class="row align-items-center mt-5">
                <div class="col-12">
                    <div class="d-flex align-items-center"
                        [ngClass]="!isMobileXL() ? 'justify-content-start' : 'justify-content-center'">
                        <p class="mat-card-header-titulo">
                            {{Etiquetas.Titulo}}</p>
                        <button class="ms-5" *ngIf="alta" mat-flat-button color="accent" (click)="pv(0,1)">
                            <mat-icon>add</mat-icon>
                            Nuevo pedido</button>
                    </div>
                </div>

                <div class="col-12 order-xxl-3 order-xl-3 order-lg-3 mt-4 mb-4">
                    <mat-divider></mat-divider>
                </div>

            </div>

        </div>

    </div>
</div>
<div class="container-custom-content animate__animated animate__fadeIn  buscador-pedidos">

    <mat-accordion>
        <mat-expansion-panel [expanded]="true" hideToggle #panel="matExpansionPanel">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Parametros de búsqueda
                </mat-panel-title>
                <mat-icon style="color: white; margin-left: auto;"
                    [style.transform]="panel.expanded ? 'rotate(180deg)' : 'rotate(0deg)'"
                    style="transition: transform 0.3s ease; color: white; margin-left: auto;">
                    expand_more
                </mat-icon>
            </mat-expansion-panel-header>
            <div class="container-fluid mt-4">

                <div class="row align-items-center">


                    <!-- 
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <mat-form-field color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.Compania}}</mat-label>
                            <mat-select [disabled]="true" [(value)]="buscadorPV.idCompania">
                                <mat-option [value]="-1">Todas</mat-option>
                                <mat-option *ngFor="let c of companias" [value]="c.id">{{c.displayValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div> -->

                    <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <mat-form-field color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.SalesOrg}}</mat-label>
                            <mat-select [disabled]="true" [(value)]="buscadorPV.idSalesOrg">
                                <mat-option [value]="-1">Todas</mat-option>
                                <mat-option *ngFor="let s of salesOrgs" [value]="s.id">{{s.displayValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div> -->

                    <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <app-selector-divisiones #selectorDivision 
                        (divisionEmitida)="recibirDivisionEmitida($event)"
                        [divisionRecibida]="divisionSeleccionada">
                        </app-selector-divisiones>
                    </div> -->
                    <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" [hidden]="!selectRegiones">
                        <app-selector-regiones #selectorRegion (regionEmitida)="recibirRegionEmitida($event)"
                            [regionRecibida]="regionSeleccionada">
                        </app-selector-regiones> 
                    </div>-->


                    <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <mat-form-field color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.MotivoRetencion}}</mat-label>
                            <mat-select [(value)]="buscadorPV.idMotivoRetencion">
                                <mat-option [value]="'-1'">Todos</mat-option>
                                <mat-option *ngFor="let mr of motivosRetencion" [value]="mr.idItem">{{mr.descripcion}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div> -->

                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                        <mat-form-field color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.FechaDesde}}</mat-label>
                            <input readonly matInput [matDatepicker]="picker" [(ngModel)]="buscadorPV.fDesde">

                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker [(ngModel)]="buscadorPV.fDesde" #picker></mat-datepicker>

                        </mat-form-field>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                        <mat-form-field color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.FechaHasta}}</mat-label>
                            <input readonly matInput [matDatepicker]="picker2" [(ngModel)]="buscadorPV.fHasta">

                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker [(ngModel)]="buscadorPV.fHasta" #picker2></mat-datepicker>

                        </mat-form-field>

                    </div>

                    <!-- <div *ngIf="autocompletableZonaVendedor" class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                        <mat-form-field color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.BuscarVendedor}}</mat-label>
                            <input (change)="handleEmptyInputVendedor($event)" matInput [matAutocomplete]="auto"
                                [formControl]="formControlAutocomplete" placeholder="Descripción">
                            <button type="button" matSuffix mat-icon-button matTooltip="{{Tooltips.LimpiarVendedor}}"
                                (click)="limpiarVendedor(true)">
                                <mat-icon color="accent-darker">close</mat-icon>
                            </button>

                            <mat-autocomplete #auto="matAutocomplete"
                                (optionSelected)='seleccionarVendedor($event.option.value)'
                                [displayWith]="getOptionText">
                                <mat-option *ngIf="isLoading" class="is-loading">Cargando...</mat-option>
                                <ng-container *ngIf="!isLoading">
                                    <mat-option *ngFor="let zv of filteredOptions" [value]="zv">
                                        {{zv.displayValue}}
                                    </mat-option>
                                </ng-container>
                            </mat-autocomplete>

                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <mat-form-field *ngIf="autocompletableZonaVendedor" color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.IdZonaVendedor}} Seleccionado</mat-label>
                            <input type="text" *ngIf="zonaVendedorSeleccionada != null" [disabled]="true" matInput
                                [value]="zonaVendedorSeleccionada.displayValue">
                            <input type="text" *ngIf="zonaVendedorSeleccionada == null" [disabled]="true" matInput
                                [value]="">
                        </mat-form-field>
                        <mat-form-field *ngIf="!autocompletableZonaVendedor && buscadorPV.idZonaVendedor" color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.IdZonaVendedor}} Seleccionado</mat-label>
                            <input type="text" [disabled]="true" matInput
                                [value]="buscadorPV.idZonaVendedor + ' - ' + buscadorPV.zonaVendedor">
                        </mat-form-field>
                    </div> -->
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <app-selector-estado-pedidos #selectorEstadoPedido
                            (estadoEmitido)="recibirEstadoEmitido($event)" [estadoRecibido]="estadoSeleccionado">
                        </app-selector-estado-pedidos>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <mat-form-field color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.NroPedido}}</mat-label>
                            <input numbersOnly [(ngModel)]="buscadorPV.nroPedido" type="text" matInput>
                        </mat-form-field>
                    </div>


                </div>
            </div>
        </mat-expansion-panel>

    </mat-accordion>

    <div class="row align-items-center mt-3 mb-3">
        <div class="mat-toolbar-custom">
            <mat-toolbar>
                <mat-toolbar-row>

                    <button (click)="buscar(0)" mat-flat-button color="accent">
                        <mat-icon>search</mat-icon>
                        Buscar</button>

                </mat-toolbar-row>

            </mat-toolbar>

        </div>

    </div>



</div>
<div class="container-fluid">
    <div class="row align-items-center justify-content-evenly">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


            <mat-form-field color="accent-darker" appearance="standard">
                <mat-label>{{Etiquetas.Buscar}}</mat-label>
                <input matInput (keyup)="applyFilterPV($event)" #input>
            </mat-form-field>
            <div class="mat-table-pedidos">
                <table mat-table matTableResponsive [dataSource]="dataSourcePV" matSort #matSortPV="matSort"
                    matSortActive="nroPedido" matSortDirection="desc">

                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Acciones}} </th>
                        <td mat-cell *matCellDef="let pvCab">
                            <div>

                                <button *ngIf="pvCab.editar" (click)="pv(pvCab.codigo,2)"
                                    matTooltip="{{Tooltips.Editar}}" mat-icon-button color="primary-darker">
                                    <mat-icon color="accent-darker">edit</mat-icon>
                                </button>

                                <button *ngIf="pvCab.ver" (click)="pv(pvCab.codigo,3)" matTooltip="{{Tooltips.Ver}}"
                                    mat-icon-button color="primary-darker">
                                    <mat-icon color="accent-darker">visibility</mat-icon>
                                </button>



                            </div>

                        </td>
                    </ng-container>


                    <ng-container matColumnDef="nroPedido">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.NroPedido}}
                        </th>
                        <td mat-cell *matCellDef="let pvCab">
                            {{pvCab.nroPedido}}
                        </td>
                    </ng-container>
                    
                    <ng-container matColumnDef="fechaCreacion">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.FechaCreacion}}
                        </th>
                        <td mat-cell *matCellDef="let pvCab">
                            {{pvCab.fechaCreacion | date:'dd/MM/yyyy HH:mm'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="nroOrdenSAP">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.NroOrdenSAP}}
                        </th>
                        <td mat-cell *matCellDef="let pvCab">
                            {{pvCab.nroOrdenSAP}}
                        </td>
                    </ng-container>

                    <!-- <ng-container matColumnDef="nroCliente">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.NroCliente}}
                        </th>
                        <td mat-cell *matCellDef="let pvCab">
                            {{pvCab.nroCliente}}
                        </td>
                    </ng-container> -->


                    <ng-container matColumnDef="nombreCliente">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.NombreCliente}}
                        </th>
                        <td mat-cell *matCellDef="let pvCab">
                            {{pvCab.nombreCliente}}
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="estado">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.Estado}}
                        </th>
                        <td mat-cell *matCellDef="let pvCab">
                            <div [ngClass]="clasePorEstado(pvCab.idEstado)">
                                {{pvCab.estado}}

                            </div>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="fechaEstado">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.FechaEstado}}
                        </th>
                        <td mat-cell *matCellDef="let pvCab">
                            {{pvCab.fechaEstado | date:'dd/MM/yyyy HH:mm'}}
                        </td>
                    </ng-container>

                    <!-- <ng-container matColumnDef="motivoRetencion">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.MotivoRetencion}}
                        </th>
                        <td mat-cell *matCellDef="let pvCab">
                            {{pvCab.motivoRetencion}}
                        </td>
                    </ng-container> -->

                    <ng-container matColumnDef="terminoPago">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.TerminoPago}}
                        </th>
                        <td mat-cell *matCellDef="let pvCab">
                            {{pvCab.terminoPago}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="idZonaVendedor">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.IdZonaVendedor}}
                        </th>
                        <td mat-cell *matCellDef="let pvCab">
                            {{pvCab.nombreVendedor}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="nombreDistribuidor">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.NombreDistribuidor}}
                        </th>
                        <td mat-cell *matCellDef="let pvCab">
                            {{pvCab.nombreDistribuidor}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="enviadoDistribuidor">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.EnviadoDistribuidor}}
                        </th>
                        <td mat-cell *matCellDef="let m">
                            <div>
                                <mat-icon color="accent-darker">{{ m.enviadoDistribuidor ?
                                    'check_box' :
                                    'check_box_outline_blank' }}
                                </mat-icon>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.TotalUSD}}
                        </th>
                        <td mat-cell *matCellDef="let pvCab">
                            {{pvCab.total | number : '1.2-2'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totalLocal">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.TotalLocal}}
                        </th>
                        <td mat-cell *matCellDef="let pvCab">
                            {{pvCab.totalLocal | number : '1.0-0'}}
                        </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumnsPV"></tr>
                    <tr mat-row *matRowDef="let pvCab; columns: displayedColumnsPV;">
                    </tr>


                    <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                        <td class="mat-cell" [attr.colspan]="displayedColumnsPV.length">
                            {{Etiquetas.SinRegistros}}
                        </td>
                    </tr>
                </table>

                <mat-paginator #matPaginatorPV="matPaginator" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons>
                </mat-paginator>
            </div>

        </div>

    </div>

</div>